import { render, staticRenderFns } from "./IoTsError.vue?vue&type=template&id=ef680498&"
import script from "./IoTsError.vue?vue&type=script&lang=ts&"
export * from "./IoTsError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports